


import { setGetMailingStatisticsScrollerUsersWithdrawalsByCurrencyAction } from '../action';
import { getMailingStatisticsScrollerUsersWithdrawalsByCurrency } from '../api/getMailingStatisticsScrollerUsersWithdrawalsByCurrency';

export const setGetMailingStatisticsScrollerUsersWithdrawalsByCurrency = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersWithdrawalsByCurrency(params);

            dispatch(setGetMailingStatisticsScrollerUsersWithdrawalsByCurrencyAction(data));

        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}